import { Checkbox, FormControl, ListItemText, MenuItem, OutlinedInput, Select, Typography } from '@mui/material';
import React from 'react';
import { isNewUi } from '../../redesign/uiMode';
import { ConstantsSymbols } from '../Common/Constants';
import { withStyles } from '@mui/styles';







const ITEM_HEIGHT = 20;
const ITEM_PADDING_TOP = 4;

const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4 + ITEM_PADDING_TOP,
			width: 120,
		},
	},
};

const Styles = theme => ({
	root: {
		'&': {
			width: '100% !important'
		},
		'& .MuiFormControl-root': {
			display: 'inline-flex',
			flexDirection: 'column',
			position: 'relative',
			minWidth: 0,
			padding: 0,
			margin: 0,
			border: 0,
			verticalAlign: 'top',
			width: '100%',
			height: 34,
			borderRadius: '6px'
		},
		'& .MuiOutlinedInput-root': {
			fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
			fontWeight: 400,
			fontSize: '1rem',
			lineHeight: '1.4375em',
			letterSpacing: '0.00938em',
			color: 'rgba(0, 0, 0, 0.87)',
			boxSizing: 'border-box',
			position: 'relative',
			cursor: 'text',
			display: 'inline-flex',
			alignItems: 'center',
			borderRadius: 4,
			height: 34,
		},
		'& .MuiSelect-select': {
			padding: '0px 32px 0px 10px',
		},
		'& .MuiSelect-nativeInput': {
			bottom: 0,
			left: 0,
			position: 'absolute',
			opacity: 0,
			pointerEvents: 'none',
			width: '100%',
			boxSizing: 'border-box',
		},
		'& .MuiOutlinedInput-notchedOutline': {
			textAlign: 'left',
			position: 'absolute',
			bottom: 0,
			right: 0,
			top: '-5px',
			left: 0,
			margin: 0,
			padding: '3.5px 8px',
			pointerEvents: 'none',
			borderRadius: 'inherit',
			borderStyle: 'solid',
			borderWidth: 1,
			overflow: 'hidden',
			borderColor: 'rgba(0, 0, 0, 0.23)',
			height: 34,
		},

		'& .MuiSvgIcon-root.MuiSvgIcon-fontSizeMedium': {
			right:'-2px'
		}
	},
});

export function VendorMapSelectControl(props) {
	const items = React.useMemo(() => {
		const sortByKey = (arr) => {
			const seen = new Set();
			return [...(arr || [])]
				.filter((item) => {
					const normalizedKey = (item?.Key ?? '').toString().trim().toLowerCase();
					if (seen.has(normalizedKey)) return false;
					seen.add(normalizedKey);
					return true;
				})
				.sort((a, b) => (a.Key || '').toString().localeCompare((b.Key || '').toString(), undefined, { sensitivity: 'base', numeric: true }));
		};
		if (props.recordType === 'Lineitems') {
			if (props.recordType === 'Lineitems') {
				let items = [...((props.fieldData['Lineitems'] && props.fieldData['Lineitems'][props.maxWeightedLine]?.line) || [])
					, ...(props.fieldData['Records'].filter((e, i) => (e.Key?.toLowerCase() === 'purchaseorder')))
					, ...((props.fieldData?.KeyValues || []).filter((e, i) => (e.Key?.toLowerCase() === 'purchaseorder')))
				];
				//return items;
				// table change;
				//let tableitems = Object.entries(props.fieldData['Table']?.Rows[0]?.Columns || {}).map((e, i) => { return { Key: e[0], Value: e[1], ValueType: 'string', parentField: 'Table' }; });
				let obj = {}
				obj['Line Items'] = sortByKey(items);
				let indicator = 0;
				//if (tableitems && tableitems.length > 0) {
				//	indicator++;
				//	obj['Table Items'] = tableitems;
				//}
				if (props.fieldData?.KeyValues && props.fieldData?.KeyValues?.length > 0) {
					indicator++;
					if (props.type === 'currency') {
						obj['KeyValue Pairs']  = sortByKey([
							...(props.fieldData?.KeyValues || []).filter((e) => e.Key?.toLowerCase().indexOf('date') === -1 && props.regex['currency'].some((k) => k.test(e.Value))
							)
						]);
					}
					else if (props.type === 'number') {
						obj['KeyValue Pairs'] = sortByKey([
							...(props.fieldData?.KeyValues || []).filter((e) => props.regex['number'].some((k) => k.test(e.Value))
							)
						]);
					}
					else {
						obj['KeyValue Pairs'] = sortByKey(props.fieldData?.KeyValues);
					}
					
					
				}
				return indicator > 0 ? obj : obj['Line Items'];
			}
		} else {

			if (props?.fieldInfo?.filterCallback) {
				let records =  [...(props.fieldData['Records'])
					, ...(props.fieldData?.KeyValues || []),
					...((props.fieldData['Lineitems'] && props.fieldData['Lineitems'][props.maxWeightedLine]?.line) || [])
				];
				return sortByKey(props.fieldInfo.filterCallback(records));
			}
			else {
				if (props.type === 'currency') {
					return sortByKey([
						...(props.fieldData['Records'] || []).filter((e) => {
							// Must be flagged as a currency type from OCR records
							if (e.Valuetype?.toLowerCase().indexOf('currency') === -1) {
								return false;
							}

							// Value must pass the currency regex
							return props.regex['currency'].some((k) => k.test(e.Value));
						}),

						...(props.fieldData?.KeyValues || []).filter((e) => {
							// Exclude date fields
							if (e.Key?.toLowerCase().indexOf('date') !== -1) {
								return false;
							}

							// Hotfix: include amount/montant fields even if value
							// doesn't match the currency regex
							const isKeyAmount = /amount|montant/i.test(e.Key || '');

							return (
								isKeyAmount ||
								props.regex['currency'].some((k) => k.test(e.Value))
							);
						})
					]);
				}
				else if (props.type === 'string') {
					return sortByKey([...(props.fieldData['Records']).filter((e) => e.Valuetype?.toLowerCase().indexOf('currency') === -1 &&
						e.Valuetype?.toLowerCase().indexOf('date') === -1)
						, ...(props.fieldData?.KeyValues || []).filter((e) => e.Key?.toLowerCase().indexOf('date') === -1)
					]);
				}
				else if (props.type === 'date') {
					return [...((props.fieldData['Records']).filter((e) => e.Valuetype?.toLowerCase().indexOf('date') !== -1))
						, ...((props.fieldData?.KeyValues || []).filter(e => e.Key?.toLowerCase().indexOf('date') !== -1))
					];
				}
				else {
					return sortByKey([...(props.fieldData['Records'])
						, ...(props.fieldData?.KeyValues || [])
					]);
				}
			}
			

		}
	}, []);
	
	return (
		<select key={(props.value?.mappedField || '') + (props.controlKey || '')} style={props.style.inputStyle}
			value={`${props.value?.mappedField}`}
			onChange={props.onChange}
			disabled={props.readOnly }
		>
			<option key={(props.controlKey + 1)} value=''>{isNewUi() ? 'Not mapped' : 'Select Option'}</option>
			{
				(Array.isArray(items)) ?
					items.map((item, index) => {
						let types = props.type.split('|')
						return /*(types.indexOf(item.Valuetype)!== -1)*/ true ? <option
							key={(item?.key || '') + (props.recordType || '') + ((props.recordType || '') + '' + (props.controlKey)) + index}
							value={`${item.Key}`}>{item.Key}</option> : <></>

					}) : Object.entries(items).map((e, i) => {
						return (<optgroup key={(props.recordType || '') + ((props.recordType || '') + '' + (props.controlKey)) + i} label={e[0]}>
							{
								e[1].map((k, j) => {
									return (
										<option value={k.Key} key={i + '-' + j}>{k.Key}</option>
									)
								})
							}
						</optgroup>);
					})
			}
		</select>
	);
}


export function VendorMapSelectControl2(props) {
	const items = React.useMemo(() => {
		let updatedFieldData = [...props.fieldData];

		if (props.invoiceDocument?.taxes) {
			props.invoiceDocument.taxes.forEach(t => {
				if (!updatedFieldData.find(tt => tt.taxCode === t.taxCode)) {
					updatedFieldData.push({ taxCode: t.taxCode, taxDesc: t.taxDesc });
				}
			});
		}

		return updatedFieldData;
	}, [props.fieldData, props.invoiceDocument?.taxes]);
	return (
		<select key={(props.value?.mappedField || '') + (props.controlKey || '')} style={props.style.inputStyle} value={props.value}
			onChange={props.onChange}
			disabled={props.readOnly}
		>
			<option key={(props.controlKey + 1)} value=''>{isNewUi() ? 'Not mapped' : 'Select Option'}</option>
			{

				items.map((item, index) => {
					return (<option
						key={item?.taxDesc + (props.recordType || '') + ((props.recordType || '') + '' + (props.controlKey)) + index}
						value={item?.taxCode}>{item?.taxDesc}</option>)
				})
			}
		</select>
	)
}



function _MultiSelectTax({ options, selectedValues = [], onChange, classes }) {
	return (
		<FormControl className={classes.root} sx={{ width: 280 }}>
			<Select
				labelId="multi-select-checkbox-label"
				id="multi-select-checkbox"
				multiple
				value={selectedValues}
				onChange={onChange}
				input={<OutlinedInput />}
				displayEmpty
				renderValue={(selected) => {
					if (!selected || selected.length === 0) {
						return <Typography color="gray">{isNewUi() ? 'Select tax(es)' : 'Select Invoice Tax(es)'}</Typography>;
					}
					return selected.join(', ');
				}}
				>
				{options.map((option) => (
					<MenuItem key={option} value={option}>
						<Checkbox checked={selectedValues.includes(option)} />
						<ListItemText primary={option} />
					</MenuItem>
				))}
			</Select>
		</FormControl>
	);
}

const MultiSelectTax = withStyles(Styles)(_MultiSelectTax);

const removeNonNumberPrefix = (charArray) => {
	if (charArray === null || charArray === undefined) {
		return charArray;
	}
	if (typeof charArray !== 'string') {
		charArray = String(charArray);
	}

	let start = 0;
	while (start < charArray.length && /[^0-9.\-]/.test(charArray[start])) {
		start++;
	}

	if (start === charArray.length) {
		return charArray;
	}

	let end = charArray.length - 1;
	while (end >= start && /[^0-9.\-]/.test(charArray[end])) {
		end--;
	}

	return charArray.slice(start, end + 1);
};

const removeCurrencyCharacters = (charArray) => {
	if (charArray === null || charArray === undefined) {
		return charArray;
	}
	const tokens = [
		"US$",
		"(£)",
		"$",
		"AUD $",
		"£",
		"USD$",
		"USD",
		"AUD",
		"CAD$"
	];
	let nString = typeof charArray === 'string' ? charArray : String(charArray);
	for (let token of tokens) {
		nString = nString.replaceAll(token, '');
	}
	return nString;
}


export function VendorMapSelectControl3(props) {
	// Memoize the filtered key values
	const keyValues = React.useMemo(() => {
		if (!props.fieldData?.KeyValues?.length) return [];

		// Create regex test functions once
		const currencyTests = props.regex['currency'];
		const numberTests = props.regex['number'];

		// Single filter pass with combined conditions
		return props.fieldData.KeyValues.reduce((filtered, entry) => {
			const key = entry.Key;
			const value = entry.Value;
			
			// Skip if key contains 'date' (case insensitive)
			if (key.toLowerCase().includes('date') || !key?.trim()) return filtered;


			let sanitizedValue = removeCurrencyCharacters(value);
			sanitizedValue = removeNonNumberPrefix(sanitizedValue);
			sanitizedValue = sanitizedValue?.replaceAll(',', '')?.trim();

			// Check if value matches currency or number regex
			const isCurrency = currencyTests.some(regex => regex.test(sanitizedValue));
			const isNumber = numberTests.some(regex => regex.test(sanitizedValue));

			if (isCurrency || isNumber) {
				filtered.push(key);
			}

			return filtered;
		}, []);
	}, [props.fieldData?.KeyValues, props.regex]);

	// Memoize the selected values
	const selection = React.useMemo(() => {
		return props.value ? props.value.split(ConstantsSymbols.TAXKEYS_DELIM) : [];
	}, [props.value]);

	return (
		<MultiSelectTax
			onChange={props.onChange}
			options={keyValues}
			selectedValues={selection}
		/>
	);
}


